// Provide Vue compile-time feature flags for dependencies that ship the ESM bundler build.
// This avoids runtime warnings when libraries bundle Vue as an ESM build without webpack
// Define them before any module imports that may load Vue (e.g. @n8n/chat).

// Enable the Options API (needed by some Vue libraries)
window.__VUE_OPTIONS_API__ = true;
// Disable Vue devtools in production (default for CRA production build)
window.__VUE_PROD_DEVTOOLS__ = false;
// Disable hydration mismatch details (avoids extra bundle size)
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
